/* -------------------------------------------------------------------------- */
/*                        Drawer styles                        */
/* -------------------------------------------------------------------------- */

@import './bq-drawer.variables';

:host {
  @apply invisible #{!important};
}

:host(.bq-drawer--open) {
  @apply visible #{!important};
}

.bq-drawer {
  @apply fixed z-[--bq-drawer--zIndex] flex flex-col gap-[--bq-drawer--gap] bg-ui-primary shadow-m is-[--bq-drawer--width] max-is-full p-b-[--bq-drawer--paddingY] p-i-[--bq-drawer--paddingX] inset-b-0;
}
